//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getPinterestUserId = createSelector(
  (state: ICuralateStore) => state.pinterest.user.user,
  (user) => user?.id,
);
